import { render, staticRenderFns } from "./ImageSlider.vue?vue&type=template&id=1320220c&scoped=true&"
import script from "./ImageSlider.vue?vue&type=script&lang=ts&"
export * from "./ImageSlider.vue?vue&type=script&lang=ts&"
import style0 from "./ImageSlider.vue?vue&type=style&index=0&id=1320220c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1320220c",
  null
  
)

export default component.exports